<div class="side-edit-mode">
    <div class="section-block" *ngIf="!fromFile && formType==3">
        <div class="section-block-inner">
            <div class="section-content no-padding-bottom">
                <h2 class="title">{{'form.title.ASSIGNMENT_NEW_WELCOME' | translate}}</h2>
            </div>
        </div>
    </div>
    <div class="section-block" [hidden]="!fromFile && !fileUploaded">
        <div class="section-block-inner">
            <div class="section-content no-padding-bottom">
                <h2 class="title" *ngIf="!fromFile && formType==3">{{'form.title.ASSIGNMENT_NEW_WELCOME' | translate}}</h2>
                <h2 class="title" *ngIf="fromFile">{{'form.title.ASSIGNMENT_NEW_WELCOME_FILE' | translate}}</h2>
                <rl-file-upload [id]="formType + 'fileInput'" (onUpload)="onfileUploaded($event)" (onRemove)="onfileRemoved()"></rl-file-upload>
            </div>
        </div>
    </div>    
    <div class="padding-item no-padding-bottom no-padding-top" *ngIf="fromFile && fileUploaded && licenseTypes?.length">
        <div class="normal-cb" *ngIf="licenseTypes.length == 1">
            <input [id]="licenseTypes[0].code" type="checkbox" [value]="licenseTypes[0].text" [(ngModel)]="item.licenseType" [checked]="licenseTypes[0].checked">
            <label [for]="licenseTypes[0].code">
                <span [innerHTML]="licenseTypes[0].text | customerTranslate"></span>
            </label>
        </div>
        <ul *ngIf="licenseTypes.length > 1">
            <li *ngFor="let l of licenseTypes; let i = index;">
                <div class="normal-rb">
                    <input type="radio" [value]="l.code" [name]="l.code" [checked]="l.defaultOption" [(ngModel)]="item.licenseType" [id]="l.code">
                    <label [innerHTML]="l.text | customerTranslate" [for]="l.code"></label>
                </div>
            </li>
        </ul>
    </div>
    <div [hidden]="fromFile && !fileUploaded" class="collection-container collection-sidebar">
        <div class="scroll-content">
            <div class="scroll-erea side-edit-form-height no-padding-bottom no-padding-top">
            	<rl-form [type]="formType" [config]="editFormConfig"></rl-form>
            </div>
        </div>
        <ng-content></ng-content>
        <rl-please-wait *ngIf="busy"></rl-please-wait>
        <div class="justify-content padding-item">
            <div *ngIf="showButton('CANCEL')" class="flex-start">
                <button (click)="onCancel.emit()" type="button" class="btn btn-default" [ngClass]="{'disabled' : busy}" [disabled]="busy" id="form-cancel" [rlAria]="'general.cancel' | translate">
                    {{'general.cancel' | translate}}
                </button>
            </div>
            <div class="flex-end">
                <ng-container [ngSwitch]="type">
                    <ng-container *ngSwitchCase="'new'">
                        <button *ngIf="showButton('CREATE')" [ngClass]="{'disabled' : busy}" [disabled]="busy" class="btn btn-primary" type="button" (click)="add()" [rlAria]="'editForm.buttons.create' | translate" id="new-form-create">
                            {{'editForm.buttons.create' | translate}}
                        </button>                        
                        <button *ngIf="showButton('ADD_AND_CLOSE')" [ngClass]="{'disabled' : busy}" [disabled]="busy" class="btn btn-stroke half-margin-right" type="button" (click)="add(true)" [rlAria]="'add.it.and.close' | translate" id="form-add-close">
                            {{'add.it.and.close' | translate}}
                        </button>
                        <button *ngIf="showButton('ADD')" [ngClass]="{'disabled' : busy}" [disabled]="busy" class="btn btn-primary" type="button" (click)="add()" [rlAria]="'add.it' | translate" id="new-form-add">
                            {{'add.it' | translate}}
                        </button>
                    </ng-container>
                    <ng-container *ngSwitchCase="'edit'">
                        <button *ngIf="showButton('SAVE')" class="btn btn-stroke" [ngClass]="{'disabled' : busy}" [disabled]="busy" type="button" (click)="save()" [rlAria]="'general.save' | translate" id="form-save">
                            {{'general.save' | translate}}
                        </button>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
</div>